import { warehouseTranslations } from "./warehouse/i18n";
import { knowledgeSpacesI18n } from "./knowledgeSpaces/i18n";
import { processMiningTranslations } from "./processMining/i18n";
import { productComplianceI18n } from "./productCompliance/i18n";
import { baseTranslationsDe } from "./i18n/de";
import { baseTranslationsEn } from "./i18n/en";
import { baseTranslationsEs } from "./i18n/es";
import { SFWTranslations } from "./shopFloorWalk/i18n";

export default {
  de: {
    ...productComplianceI18n.de,
    ...warehouseTranslations.de,
    ...processMiningTranslations.de,
    ...knowledgeSpacesI18n.de,
    ...SFWTranslations.de,
    ...baseTranslationsDe,
    "": "",
  },

  en: {
    ...productComplianceI18n.en,
    ...warehouseTranslations.en,
    ...knowledgeSpacesI18n.en,
    ...processMiningTranslations.en,
    ...SFWTranslations.en,
    ...baseTranslationsEn,
    "": "",
  },

  es: {
    ...productComplianceI18n.es,
    ...warehouseTranslations.es,
    ...knowledgeSpacesI18n.es,
    ...processMiningTranslations.es,
    ...SFWTranslations.es,
    ...baseTranslationsEs,
    "": "",
  },
};

// Merge two message objects, the second one will override message from the first one
export function mergeMessages(messages1: object, messages2: object) {
  const result = {};
  [...new Set([...Object.keys(messages1), ...Object.keys(messages2)])].forEach(
    (langCode) =>
      (result[langCode] = {
        ...messages1[langCode],
        ...messages2[langCode],
      }),
  );
  return result;
}
